module.exports = __webpack_public_path__ + "img/BG2.cb3870fa.png";